exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-popup-container{position:fixed;z-index:1000;left:40%;top:40%;padding:5px;width:440px;height:141px;border-radius:3px;background-color:#fff;box-shadow:0 3px 15px 8px #828282;padding-top:50px;padding-left:40px;font-family:Roboto-Regular}.notification-popup-container .notification-popup-title{font-size:15px;line-height:21px;color:#474747}.notification-popup-container .notification-popup-close-button{float:right;margin-top:-50px;margin-right:6px}.notification-popup-container .notification-popup-message{margin-top:10px;max-width:400px;word-wrap:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30e2c78f","scoped":false,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/NotificationPopup.vue
// module id = 464
// module chunks = 0